import HttpService from './http.service.js'

class MeService {
  async me(payload) {
    const meEndpoint = 'me'
    return HttpService.get(meEndpoint, payload)
  }

  async feedback(payload) {
    const feedbackEndpoint = 'me/feedback'
    return HttpService.post(feedbackEndpoint, payload)
  }

  async profileData(payload) {
    const profileDataEndpoint = 'me/profile_data'
    return HttpService.get(profileDataEndpoint, payload)
  }

  async unsubscribe(payload) {
    const unsubscribeEndpoint = 'me/unsubscribe'
    return HttpService.post(unsubscribeEndpoint, payload)
  }

  async setPublicName(payload) {
    const publicNameEndpoint = '/me/set_public_name'
    return HttpService.post(publicNameEndpoint, payload)
  }

  async setFaculties(payload) {
    const setFacultiesEndpoint = '/me/set_faculties'
    return HttpService.post(setFacultiesEndpoint, payload)
  }

  async setExamTypes(payload) {
    const setExamTypesEndpoint = '/me/set_exam_types'
    return HttpService.post(setExamTypesEndpoint, payload)
  }

  async updateProfileData(payload) {
    const updateProfileDataEndpoint = '/me/update_profile_data'
    return HttpService.post(updateProfileDataEndpoint, payload)
  }

  async updateHasDetails(payload) {
    const updateHasDetailsEndpoint = '/me/update_has_details'
    return HttpService.post(updateHasDetailsEndpoint, payload)
  }

  async updateTutorialState(payload) {
    const updateTutorialStateEndpoint = '/me/update_tutorial_state'
    return HttpService.post(updateTutorialStateEndpoint, payload)
  }

  async updateWantInCommunity(payload) {
    const updateWantInCommunityEndpoint = '/me/update_want_in_community'
    return HttpService.post(updateWantInCommunityEndpoint, payload)
  }

  async updateLastTimeCommunityBanner() {
    const updateLastTimeCommunityBannerEndpoint =
      '/me/last_community_banner_timestamp'
    return HttpService.post(updateLastTimeCommunityBannerEndpoint)
  }

  async getProfileData() {
    const getProfileDataEndpoint = '/me/user_profile_data'
    return HttpService.get(getProfileDataEndpoint)
  }

  async updateUserProfileData(payload) {
    const updateUserProfileDataEndpoint = '/me/update_user_profile_data'
    return HttpService.post(updateUserProfileDataEndpoint, payload)
  }
  async updateUserUniversities(payload) {
    const updateUserUniversitiesEndpoint = '/me/update_user_universities'
    return HttpService.post(updateUserUniversitiesEndpoint, payload)
  }

  async hasSubscription() {
    const hasSubscriptionEndpoint = '/me/has_subscription'
    return HttpService.get(hasSubscriptionEndpoint)
  }
}

export default new MeService()
